export const STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DISCONTINUED: 'discontinued'
};

/** True when a product/option flag is stored as active. */
export function isActiveStatus(value: unknown): boolean {
    if (value === true || value === 1) {
        return true;
    }
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        return (
            normalized === STATUSES.ACTIVE ||
            normalized === 'true' ||
            normalized === 'activo'
        );
    }
    return false;
}

/** Persists checkbox flags as `active` / `inactive`. */
export function toActiveStatus(checked: boolean): string {
    return checked ? STATUSES.ACTIVE : STATUSES.INACTIVE;
}

/** Canonical active/inactive value from mixed API data. */
export function toCanonicalActiveStatus(value: unknown): string {
    return toActiveStatus(isActiveStatus(value));
}

/** True when an option checkbox should be persisted. */
export function didActiveStatusChange(
    original: unknown,
    current: unknown
): boolean {
    return (
        toCanonicalActiveStatus(original) !== toCanonicalActiveStatus(current)
    );
}
